import React, { FC } from 'react';
import { Asset, InfoFilledIcon } from '@clearcover/atlas';
import styles from './styles.module.css';

export const ChangeMessage: FC = ({ children }) => {
  return (
    <div className={styles.message}>
      <Asset
        className={styles.messageIcon}
        icon={InfoFilledIcon}
        height={18}
        width={18}
        description="info"
      />
      {children}
    </div>
  );
};
